import register from '../register';

register( 'tech-specs-toggle', function() {

  let trigger   = document.querySelector('.js-tech-specs-toggle-trigger');
  let container = document.querySelector('.js-tech-specs-container');

  trigger.addEventListener( 'click', function() {
    container.classList.toggle('is-expanded');
  });

});

export default undefined;
